import { useEffect, useState, useMemo, useRef } from 'react'
import Nav from '../Nav'
import styles from './index.less'
import AssetPopup from '../AssetPopup'
import UserInfoPopup from '../UserInfoPopup'
import ToolsCrumbNav from '../ToolsNavPopup/CrumbNav'
import LoginDialog from '@/components/LoginDialog'
import CreatePlatform from '../CreatePlatform'
import { history, useRouteProps } from 'umi'
import classNames from 'classnames'
import { addCookie, deleteCookie, getCookie } from '@/utils/cookie'
import PopUser from '../PopUser'
import { useStore, setIsLogin } from '@/states/store'
import { getBosInfo, getUserInfo } from '@/utils/getUserInfo'
import logo from '@/assets/icon/logo/logo.svg'
import { ReactComponent as Logo } from '@/assets/icon/logo/logo.svg'
import { ReactComponent as PersonLogo } from '@/assets/icon/logo/crumb-person.svg'
import { ReactComponent as CreateLogo } from '@/assets/icon/logo/crumb-create.svg'
import { Popover } from 'antd'
import { isMac } from '@/utils/util'
import { openLoginDialog } from '@/components/LoginDialog/openLoginDialog'
import BindTel from '@/components/BindTel'
import { MemberType } from '@/constants'
import PopCode from '../PopCode'
import goToRoute from '@/utils/goToRoute'
import RprmUtils from '@/utils/dot'
import { getQuery } from '@/utils'
import { login } from '@/components/LoginDialog/api'
import { setHeaders } from '@/utils/request'
import { getOemInfos } from '@/utils/intercept'
import openPayDialog from '@/components/PayDialog'
import { redirectToOem } from '@/utils/oem'
import wsStore from '@/states/ws'
import { useSnapshot } from 'umi'
import { openBosIdSwitchDialog } from '../BosIdSwitchDialog'
import { openTipDialog } from '../TipDialog'

export default () => {
  const router = useRouteProps()
  const [showLogin, setShowLogin] = useState(false)
  const state = useSnapshot(wsStore)

  const baseStore = useStore()
  const isOEM = baseStore?.userInfo?.oemFlag === 1

  const [showMask, setShowMask] = useState(false)

  const [showBindTel, setShowBindTel] = useState(false)
  const query = getQuery()

  useEffect(() => {
    if(!/wime-ai/i.test(window.location.hostname)&&!/wai-c-web/i.test(window.location.hostname)&&!query.oemCode&&!getCookie('token')){
      redirectToOem()
      return
    }
    if (query?.oemCode) {
      //需要去进行免登
      if(getCookie('saasBosId')&&query.bosId!==getCookie('saasBosId')&&query.bosId){
        //两个bosid不一致，需要重新登录
        // openBosIdSwitchDialog({newBosId:query.bosId})
        // return
      }
      // console.log('oemCode',query.oemCode)
      const isFlag = getCookie('saasBosId') && query.bosId !== getCookie('saasBosId')
      login({ authCode: query.oemCode, loginType: 4 }).then(async (res: any) => {
        // console.log('login res ', res)
        if (res) {
          const oldToken = getCookie('token')
          deleteCookie('userId')
          deleteCookie('token')
          res.data?.userId && addCookie('userId', res.data.userId, 24 * 30)
          res.data?.token && addCookie('token', res.data.token, 24 * 30)
          setHeaders()
          setIsLogin(true)
          if(oldToken!==res.data.token||state.webSocketState!==WebSocket.OPEN){
            // state.close()
            // setTimeout(()=>{
              state.forceInit(res.data.token)
              // },500)
           }
          getOemInfos(true)
          await getUserInfo();

          const url = new URL(window.location.href);
          if(query.bosId&&query.key){
            deleteCookie('saasBosId')
            deleteCookie('saasKey')
            addCookie('saasBosId', query.bosId, 24 * 30)
            addCookie('saasKey', query.key, 24 * 30)
            url?.searchParams?.delete('bosId'); // 删除指定参数
            url?.searchParams?.delete('key'); // 删除指定参数
          }
          url?.searchParams?.delete('oemCode'); // 删除指定参数
          // url?.searchParams?.delete('openPay'); // 删除指定参数
          if(isFlag){
            url.searchParams.append('showTips', 'true')
          }
          RprmUtils.initializePublicParams()
          window.history?.replaceState({}, '', url);
          setTimeout(()=>{
            if(isFlag){
              state.onRefreshPage()
            }else{
              // window.location.reload()
              if (query.openPay) {
                openPayDialog({});
                const url = new URL(window.location.href);
                url?.searchParams?.delete('openPay'); // 删除指定参数
                window.history?.replaceState({}, '', url);
              }
            }
          },500)

        }
      })
      getBosInfo()
      return
    }
    setIsLogin(!!getCookie('token'))

    // if (!router.meta?.hideOperation) {
    getUserInfo()



    if(isOEM){
      if(query.openPay){
        openPayDialog({})
        const url = new URL(window.location.href);
        url?.searchParams?.delete('openPay'); // 删除指定参数
        window.history?.replaceState({}, '', url);
      }
      getBosInfo()
      if(query.showTips){
        openTipDialog({onClose:()=>{
        }})
      }
    }

    // }

    // preloadImg([
    //   'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/yaoqingyoulirukou-hover@3x.png',
    //   'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/99kaitonghuiyuan-hover@3x.png'
    // ])
  }, [])

  const onLogin = () => {}

  const preloadImg = (imgUrls: any) => {
    imgUrls.forEach((imgUrl: any) => {
      // 生成图片对象
      const img = new Image()
      img.src = imgUrl
    })
  }

  const openLogin = () => {
    openLoginDialog({})
  }

  // 小工具页面
  const isToolsPage = useMemo(() => {
    return router.path.startsWith('/tools/')
  }, [router?.path])

  return (
    <>
      <header
        style={{ backgroundColor: showMask ? '#fff' : 'transparent' }}
        id="header"
        className={classNames(styles.header, router.meta?.hideBorder && styles.noBorder)}
      >
        <div className={styles.main}>
          <div className={styles.logo}>
            <Popover
              // open={popoverShow}
              // onOpenChange={setPopoverShow}
              content={isOEM ? null : `按${isMac() ? '「⌘+D」' : '「Ctrl+D」'}收藏本站 或 拖动LOGO到书签栏`}
              placement="bottomLeft"
              overlayClassName={styles.headLogoPop}
            >
              <a href="/">
                <img style={{height:24,width:'auto'}} src={isOEM?baseStore.oemInfos?.logoUrl:logo} alt="WIME" />
              </a>
            </Popover>
            {router.meta?.crumb && (
              <>
                <div className={styles.dividerLine} />
                {router.meta?.crumb === 'preson' ? (
                  <PersonLogo className={styles.crumbLogo} />
                ) : (
                  <CreateLogo className={styles.crumbLogo} />
                )}
              </>
            )}
            {isToolsPage && <ToolsCrumbNav />}
          </div>

          {!router.meta?.hideNav && <Nav setShowMask={setShowMask} />}
        </div>

        {router.meta?.showWorkbench && <CreatePlatform />}

        {!router.meta?.hideOperation && (
          <div className={styles.operate}>
            {/* tools 页面 header右侧自定义操作 */}
            {isToolsPage && <div id="tools-page-header-right" />}
            {router.meta?.showInvite && !isOEM && (
              <div
                className={styles.invite}
                onClick={() => {
                  RprmUtils.rec(`invite_tap`, 'view', { en: 'tap', et: 'custom', element_content: '活动入口' })
                  goToRoute('/inviteActivity')
                }}
              >
                <img
                  className={styles.inviteImg}
                  src="https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/yaoqingyoulirukou@3x.png"
                  alt=""
                />
                <img
                  className={styles.inviteHoverImg}
                  src="https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/yaoqingyoulirukou-hover2@3x.png"
                  alt=""
                />
              </div>
            )}
            {/* {router.meta?.showCode&&<PopCode/>} */}
            {!baseStore.isLogin &&!isOEM&& (
              <PopUser
                openLoginModal={() => {
                  openLogin()
                }}
              />
            )}
            {!baseStore.isLogin &&!isOEM&& (
              <button
                onClick={() => {
                  openLogin()
                }}
                className={styles.login}
              >
                登录/注册
              </button>
            )}

            {baseStore.isLogin && <AssetPopup userInfo={baseStore.userInfo} isShow={baseStore.isShowRewardPop} />}

            {baseStore.isLogin && !isOEM && <UserInfoPopup userInfo={baseStore.userInfo} />}
            {baseStore.isLogin && !isOEM && baseStore.userInfo?.userId && !baseStore.showRewardPop && !baseStore.userInfo?.mobileNo && (
              <div
                className={styles.popTips}
                onClick={e => {
                  e.stopPropagation()
                  setShowBindTel(true)
                }}
              >
                <div className={`icon-SignInfoFill ${styles.tipsIcon}`} />
                <div className={styles.tipsTxt}>为保障您的资产安全，请绑定手机号</div>
                <div className={styles.bindBtn}>去绑定</div>
                <img
                  className={styles.star}
                  src="https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/tooltipzhuangshi@2x.png"
                />
              </div>
            )}
            {baseStore.isLogin && isOEM&&baseStore.bosInfo?.bosId&&<Popover
            placement="bottomLeft"
            content={baseStore.bosInfo?.bosName}
            >
              {(router.meta?.showWorkbench||isToolsPage)?
                <div className={styles.create_saaslogo}>
                  <img src={baseStore.bosInfo.logo} alt="" />
                </div>:<div className={styles.bosInfo}>
                <div className={styles.saaslogo}>
                  <img src={baseStore.bosInfo.logo} alt="" />
                </div>
                <span>{baseStore.bosInfo.bosName}</span>
              </div>}
              </Popover>}
          </div>
        )}
      </header>
      {/* <LoginDialog open={showLogin} onLogin={onLogin} onClose={() => setShowLogin(false)} /> */}
      {showMask && <div className={styles.mask} />}
      {showBindTel && (
        <BindTel
          show={showBindTel}
          closeBindTel={() => {
            setShowBindTel(false)
          }}
        />
      )}
    </>
  )
}
